import { EventName } from '../constants';
import { createAndSendEvent } from '../jumboClient';

export const SubstituteItemClickEvent = (properties = {}) =>
  createAndSendEvent(EventName.SUBSTITUTION_ITEM_CLICK_EVENT, properties);
